import { displayMessage } from "../../../services/helper"
import ELanguages from "../../../enums/ELanguages";

export default [
    {
      field: 'name',
      headerName: displayMessage('NAME'),
      flex: 1,
    },
    {
      field: 'description',
      headerName: displayMessage('DESCRIPTION'),
      flex: 1,
    },
    {
      field:'language',
      headerName:displayMessage("LANGUAGE"),
      flex: 1,
      valueGetter: (params) => Object.values(ELanguages).find((language)=> language.code === params.row?.language).description,
    }
  ];
  